import { useLocation } from 'react-router-dom';
import { useRef } from 'react';
import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import { Toast } from 'primereact/toast';
const RecurringamortListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const location = useLocation();
	const utils = useUtils();
	const filterSchema = {
		paydate: {
			tagTitle: $t('paydate'),
			value: '',
			valueType: 'single-date',
			options: [],
		},
		branchcode: {
			tagTitle: $t('branchcode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		groupid: {
			tagTitle: $t('groupid'),
			value: '',
			valueType: 'single',
			options: [],
		},
		empcode: {
			tagTitle: $t('empcode'),
			value: '',
			valueType: 'single',
			options: [],
		},
		paid: {
			tagTitle: $t('paid'),
			value: '',
			valueType: 'single',
			options: app.menus.paid2,
		},
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		},
		deposites_empcode: {
			tagTitle: $t('empcode'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	// return sum of amount for the current records
	const totalAmount = utils.sum(records, 'amount');
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/recurringamort/view/${data.collectionid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('recurringamort/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/recurringamort/edit/${data.collectionid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('recurringamort/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.collectionid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('recurringamort/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function CollectionidTemplate(data){
		if(data){
			return (
				<Link to={`/recurringamort/view/${data.collectionid}`}> { data.collectionid }</Link>
			);
		}
	}
	function MembernameTemplate(data){
		if(data){
			return (
				<>{ data.depositlookup_membername }</>
			);
		}
	}
	function GroupidTemplate(data){
		if(data){
			return (
				<>{ data.deposites_groupid }</>
			);
		}
	}
	function PaydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.paydate )}</>
			);
		}
	}
	function PaidTemplate(data){
		if(data){
			return (
				<><Chip
   label={
        String(data.paid || "").trim().toUpperCase() === "PAID"
            ? "✅ Paid"
            : "🔴 Pending"
    }
/></>
			);
		}
	}
	function EmpnameTemplate(data){
		if(data){
			return (
				<>{ data.depositlookup_empname }</>
			);
		}
	}
	function EmpcodeTemplate(data){
		if(data){
			return (
				<>{ data.deposites_empcode }</>
			);
		}
	}
	function BranchcodeTemplate(data){
		if(data){
			return (
				<>{ data.deposites_branchcode }</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-recurringamort`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">{$t('records')} <b>{ recordsPosition } {$t('of')} { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="recurringamort/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
const API_URL = `${process.env.REACT_APP_API_PATH}`;
const toast = useRef(null);
const callYourAPI = async (collectionIds) => {
    try {
      const ids = Array.isArray(collectionIds) ? collectionIds : [collectionIds];
      const response = await fetch(`${API_URL}recurringpost/post-batch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ collectionIds: ids }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'API call failed');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
	return (
<main id="RecurringamortListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('bulkRecurringPosting')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/recurringamort/add`}>
                        <Button label={$t('addNewAmort')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-fixed comp-grid" >
                        <div className="">
                            <Button 
                            label={$t('postingNow')}  
                            type="button" 
                            className="p-button w-full bg-primary"
                            onClick={() => {
                            if (selectedItems.length === 0) {
                            app.flashMsg('warning', $t('pleaseSelectRecords'));
                            return;
                            }
                            const collectionIds = selectedItems.map(item => item.collectionid);
                            // Show processing message
                            app.flashMsg('info', $t('postingInProgress'));
                            callYourAPI(collectionIds)
                            .then((response) => {
                            if (response.success) {
                            app.flashMsg('success', response.message || $t('postingSuccessful'));
                            setSelectedItems([]);
                            // Try multiple methods to refresh
                            try {
                            if (typeof pageController.refresh === 'function') {
                            pageController.refresh();
                            } else if (typeof pageController.loadPage === 'function') {
                            pageController.loadPage();
                            } else if (typeof pageController.loadData === 'function') {
                            pageController.loadData();
                            } else if (typeof pageController.reloadData === 'function') {
                            pageController.reloadData();
                            } else {
                            // Last resort: call the API again
                            pageController.loadPage(1);
                            }
                            } catch (error) {
                            console.error('Error refreshing page:', error);
                            // Fallback: reload the entire page
                            window.location.reload();
                            }
                            } else {
                            const errorMessage = response.message || $t('postingFailed');
                            if (response.errors && response.errors.length > 0) {
                            app.flashMsg('error', errorMessage + ': ' + response.errors.join(', '));
                            } else {
                            app.flashMsg('error', errorMessage);
                            }
                            }
                            })
                            .catch((error) => {
                            console.error('API call failed:', error);
                            app.flashMsg('error', error.message || $t('postingFailed'));
                            });
                            }}
                            />
                        </div>
                    </div>
                    <div className="col-12 md:col-2 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={filters.paydate.value} onChange={(e) => setFilterValue('paydate', e.value)} placeholder={$t('selectDate')}   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-2 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('branchcode', options)}  apiPath="components_data/branchcode_option_list_2"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'branchcode', e.value)} value={filters.branchcode.value} optionLabel="label" optionValue="value" options={filters.branchcode.options} placeholder={$t('selectABranch')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-2 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('groupid', options)}  apiPath="components_data/groupid_option_list_4"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'groupid', e.value)} value={filters.groupid.value} optionLabel="label" optionValue="value" options={filters.groupid.options} placeholder={$t('selectAGroup')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-2 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('empcode', options)}  apiPath="components_data/empcode_sale_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'empcode', e.value)} value={filters.empcode.value} optionLabel="label" optionValue="value" options={filters.empcode.options} placeholder={$t('selectAEmployee')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-2 comp-grid" >
                        <div className="p-3 mb-3">
                            <div className="">
                                <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'paid', e.value)} value={filters.paid.value} optionLabel="label" optionValue="value" options={filters.paid.options} placeholder={$t('selectAValue')} >
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('deposites_empcode', options)}  apiPath="components_data/deposites_empcode_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title={$t('filterByEmpcode')}  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'deposites_empcode', e.value)} value={filters.deposites_empcode.value} optionLabel="label" optionValue="value" options={filters.deposites_empcode.options} placeholder={$t('selectAValue')} >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="collectionid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="collectionid" header={$t('collectionid')} body={CollectionidTemplate} sortable={true} ></Column>
                                    <Column  field="policyno" header={$t('policyno')}  sortable={true} ></Column>
                                    <Column  field="depositlookup_membername" header={$t('membername')} body={MembernameTemplate}  ></Column>
                                    <Column  field="deposites_groupid" header={$t('groupid')} body={GroupidTemplate}  ></Column>
                                    <Column  field="period" header={$t('period')}  sortable={true} ></Column>
                                    <Column  field="paydate" header={$t('paydate')} body={PaydateTemplate} sortable={true} ></Column>
                                    <Column  field="amount" header={$t('amount')}  sortable={true} ></Column>
                                    <Column  field="paid" header={$t('paidPending')} body={PaidTemplate} sortable={true} ></Column>
                                    <Column  field="install_type" header={$t('installType')}  sortable={true} ></Column>
                                    <Column  field="depositlookup_empname" header={$t('empname')} body={EmpnameTemplate}  ></Column>
                                    <Column  field="deposites_empcode" header={$t('empcode')} body={EmpcodeTemplate}  ></Column>
                                    <Column  field="deposites_branchcode" header={$t('branchcode')} body={BranchcodeTemplate}  ></Column>
                                    <Column  field="trxnid" header={$t('trxnid')}   ></Column>
                                    <Column  field="merchanttrxnrefid" header={$t('merchanttrxnrefid')}   ></Column>
                                    <Column  field="req_status" header={$t('reqStatus')}   ></Column>
                                    <Column  field="payment_transaction_identifier" header={$t('paymentTransactionIdentifier')}   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                                <div className="flex justify-content-around font-bold p-3">
                                    <div>Total Amount : <Chip label={totalAmount} /></div>
                                </div>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
RecurringamortListPage.defaultProps = {
	primaryKey: 'collectionid',
	pageName: 'recurringamort',
	apiPath: 'recurringamort/index',
	routeName: 'recurringamortlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 50,
}
export default RecurringamortListPage;
